enum BoxShadows {
    CARD = '0 1px 5px 0 rgb(0 0 0 / 15%)'
}

export default BoxShadows;